import React from 'react';
import { useField } from 'react-final-form';
import classNames from 'classnames';

import ValidationError from '../ValidationError/ValidationError';

import css from './FieldRadioButtonGroup.module.css';

const FieldRadioButtonGroup = ({ name, rootClassName, className, children, ...fieldConfig }) => {
  const { meta } = useField(name, fieldConfig);

  return (
    <div className={classNames(rootClassName || css.root, className)}>
      {children}
      <ValidationError fieldMeta={meta} />
    </div>
  );
};

export default FieldRadioButtonGroup;
